/* Trichome Seeds – storefront behaviour on top of Dawn */
(function () {
  'use strict';
  /* global PUB_SUB_EVENTS */

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function safeGet(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
  function safeSet(key, val) { try { window.localStorage.setItem(key, val); } catch (e) { /* ignore */ } }

  function formatMoney(cents) {
    var fmt = (window.TrichomeSettings && window.TrichomeSettings.moneyFormat) || '€{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var noDecimals = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimalsComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDecimalsComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/, withDot);
  }

  /* ---------------------------------------------------------------- Age gate */
  function initAgeGate() {
    var gate = $('[data-ts-agegate]');
    if (!gate) return;
    if (window.Shopify && window.Shopify.designMode && !gate.hasAttribute('data-preview')) return;
    var key = 'trichome-age-verified';
    if (safeGet(key) === 'yes') return;
    gate.hidden = false;
    document.documentElement.classList.add('ts-age-locked');
    var yes = $('[data-ts-age-yes]', gate);
    var no = $('[data-ts-age-no]', gate);
    if (yes) yes.focus();
    yes && yes.addEventListener('click', function () {
      safeSet(key, 'yes');
      gate.hidden = true;
      document.documentElement.classList.remove('ts-age-locked');
    });
    no && no.addEventListener('click', function () {
      $('[data-ts-age-ask]', gate).hidden = true;
      $('[data-ts-age-denied]', gate).hidden = false;
    });
  }

  /* ---------------------------------------------------------------- Mobile drawer */
  function initDrawer() {
    var drawer = $('#TsDrawer');
    if (!drawer) return;
    var openBtn = $('[data-ts-drawer-open]');
    var open = function () {
      document.body.classList.add('ts-drawer-open');
      drawer.setAttribute('aria-hidden', 'false');
      openBtn && openBtn.setAttribute('aria-expanded', 'true');
      var first = $('a, button, input', drawer);
      setTimeout(function () { first && first.focus(); }, 50);
    };
    var close = function () {
      document.body.classList.remove('ts-drawer-open');
      drawer.setAttribute('aria-hidden', 'true');
      openBtn && openBtn.setAttribute('aria-expanded', 'false');
    };
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-ts-drawer-open]')) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-ts-drawer-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    $$('.ts-drawer__nav a, .ts-drawer__foot a', drawer).forEach(function (a) { a.addEventListener('click', close); });
  }

  /* ---------------------------------------------------------------- Reveal on scroll */
  function initReveal() {
    var els = $$('.ts-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------- Cart helpers */
  function cartDrawer() { return document.querySelector('cart-drawer'); }

  function addItems(items) {
    var drawer = cartDrawer();
    var body = { items: items };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    } else {
      body.sections = ['cart-icon-bubble'];
    }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Could not add to basket');
        if (drawer && drawer.renderContents) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else if (res.sections && res.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
            var inner = doc.querySelector('.shopify-section');
            if (inner) bubble.innerHTML = inner.innerHTML;
          }
        }
        if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'trichome', cartData: res });
        }
        refreshCartBar();
        return res;
      });
  }
  window.TrichomeAddItems = addItems;

  /* ---------------------------------------------------------------- Mobile cart bar */
  function renderCartBar(cart) {
    var bar = $('[data-ts-cartbar]');
    $$('[data-ts-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    if (!bar) return;
    var tpl = document.body.getAttribute('data-template') || '';
    var hide = cart.item_count === 0 || tpl.indexOf('cart') === 0;
    bar.hidden = hide;
    document.body.classList.toggle('ts-has-cartbar', !hide);
    var c = $('[data-ts-cartbar-count]', bar);
    var t = $('[data-ts-cartbar-total]', bar);
    if (c) c.textContent = cart.item_count;
    if (t) t.textContent = formatMoney(cart.total_price);
  }
  function refreshCartBar() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCartBar)
      .catch(function () {});
  }
  function initCartBar() {
    var bar = $('[data-ts-cartbar]');
    if (!bar) return;
    var count = parseInt(bar.getAttribute('data-count') || '0', 10);
    var tpl = document.body.getAttribute('data-template') || '';
    var hide = count === 0 || tpl.indexOf('cart') === 0;
    bar.hidden = hide;
    document.body.classList.toggle('ts-has-cartbar', !hide);
    if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (evt && evt.source === 'trichome') return;
        refreshCartBar();
      });
    }
  }

  /* ---------------------------------------------------------------- Collection page */
  function initCollection() {
    var root = $('[data-ts-collection]');
    if (!root) return;
    var viewKey = 'trichome-shop-view';

    // Sort
    var sort = $('[data-ts-sort]', root);
    sort && sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });

    // Available only (client side)
    var toggle = $('[data-ts-hide-soldout-toggle]', root);
    var shown = $('[data-ts-shown]', root);
    var updateCount = function () {
      if (!shown) return;
      var grid = $$('.ts-grid > li', root);
      var visible = grid.filter(function (li) { return !(toggle && toggle.checked && li.classList.contains('ts-is-soldout')); });
      shown.textContent = visible.length;
    };
    if (toggle) {
      if (safeGet('trichome-hide-soldout') === '1') toggle.checked = true;
      var apply = function () {
        root.setAttribute('data-ts-hide-soldout', toggle.checked ? 'true' : 'false');
        safeSet('trichome-hide-soldout', toggle.checked ? '1' : '0');
        updateCount();
      };
      toggle.addEventListener('change', apply);
      apply();
    }

    // Grid / catalog view
    var btns = $$('[data-ts-view-btn]', root);
    var setView = function (v) {
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ts-view-btn') === v ? 'true' : 'false'); });
      $$('[data-ts-view]', root).forEach(function (el) { el.hidden = el.getAttribute('data-ts-view') !== v; });
      safeSet(viewKey, v);
    };
    btns.forEach(function (b) { b.addEventListener('click', function () { setView(b.getAttribute('data-ts-view-btn')); }); });
    if (btns.length && safeGet(viewKey) === 'catalog') setView('catalog');

    // Catalog quantities
    var catalog = $('[data-ts-catalog]', root);
    if (!catalog) return;
    var bar = $('[data-ts-catalog-bar]', root);
    var rows = $$('[data-ts-row]', catalog);
    var qty = function (row) { return parseInt($('[data-ts-qty]', row).textContent, 10) || 0; };
    var setQty = function (row, n) { $('[data-ts-qty]', row).textContent = Math.max(0, Math.min(99, n)); };
    var flash = function (row) {
      var b = $('[data-ts-icon-basket]', row), c = $('[data-ts-icon-check]', row);
      if (!b || !c) return;
      b.hidden = true; c.hidden = false;
      setTimeout(function () { b.hidden = false; c.hidden = true; }, 1600);
    };
    var updateBar = function () {
      var packs = 0, strains = 0, total = 0;
      rows.forEach(function (row) {
        var n = qty(row);
        if (n > 0 && !row.classList.contains('ts-is-soldout')) {
          packs += n; strains += 1; total += n * parseInt(row.getAttribute('data-price'), 10);
        }
      });
      if (!bar) return;
      bar.hidden = packs === 0;
      $('[data-ts-catalog-summary]', bar).textContent =
        packs + ' pack' + (packs > 1 ? 's' : '') + ' selected, ' + strains + ' strain' + (strains > 1 ? 's' : '');
      $('[data-ts-catalog-total]', bar).textContent = formatMoney(total);
    };

    catalog.addEventListener('click', function (e) {
      var step = e.target.closest('[data-ts-step]');
      var one = e.target.closest('[data-ts-add-one]');
      var row = e.target.closest('[data-ts-row]');
      if (!row) return;
      if (step) {
        setQty(row, qty(row) + parseInt(step.getAttribute('data-ts-step'), 10));
        updateBar();
      } else if (one) {
        var n = Math.max(1, qty(row));
        one.disabled = true;
        addItems([{ id: parseInt(row.getAttribute('data-variant-id'), 10), quantity: n }])
          .then(function () { setQty(row, 0); flash(row); updateBar(); })
          .catch(function (err) { window.alert(err.message); })
          .finally(function () { one.disabled = false; });
      }
    });

    var addAll = bar && $('[data-ts-add-all]', bar);
    addAll && addAll.addEventListener('click', function () {
      var items = [], picked = [];
      rows.forEach(function (row) {
        var n = qty(row);
        if (n > 0 && !row.classList.contains('ts-is-soldout')) {
          items.push({ id: parseInt(row.getAttribute('data-variant-id'), 10), quantity: n });
          picked.push(row);
        }
      });
      if (!items.length) return;
      addAll.disabled = true;
      addItems(items)
        .then(function () { picked.forEach(function (r) { setQty(r, 0); flash(r); }); updateBar(); })
        .catch(function (err) { window.alert(err.message); })
        .finally(function () { addAll.disabled = false; });
    });
  }

  /* ---------------------------------------------------------------- Product page */
  function initProduct() {
    var input = $('[data-ts-qty-input]');
    if (input) {
      var packs = $$('[data-ts-pack]');
      var sync = function () {
        var v = parseInt(input.value, 10) || 1;
        packs.forEach(function (p) { p.setAttribute('aria-pressed', parseInt(p.getAttribute('data-ts-pack'), 10) === v ? 'true' : 'false'); });
      };
      $$('[data-ts-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-ts-qty-step'), 10);
          input.value = Math.max(1, Math.min(99, v));
          sync();
        });
      });
      packs.forEach(function (p) { p.addEventListener('click', function () { input.value = p.getAttribute('data-ts-pack'); sync(); }); });
      input.addEventListener('input', sync);
    }
    var bonus = $('[data-ts-bonus]');
    if (bonus) {
      var hidden = $('[data-ts-bonus-input]');
      var cur = $('[data-ts-bonus-current]', bonus);
      $$('[data-ts-bonus-opt]', bonus).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-ts-bonus-opt]', bonus).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          var val = b.getAttribute('data-ts-bonus-opt');
          if (hidden) hidden.value = val;
          if (cur) cur.textContent = val;
        });
      });
    }
  }

  /* ---------------------------------------------------------------- Seed finder */
  function initQuiz() {
    var root = $('[data-ts-quiz]');
    if (!root) return;
    var dataEl = $('[data-ts-quiz-products]');
    var products = [];
    try { products = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { products = []; }
    var total = parseInt(root.getAttribute('data-total'), 10);
    var steps = $$('[data-ts-step-index]', root);
    var card = $('[data-ts-quiz-card]', root);
    var result = $('[data-ts-quiz-result]', root);
    var back = $('[data-ts-quiz-back]', root);
    var dots = $$('[data-ts-quiz-dots] span', root);
    var picks = [];
    var step = 0;
    var winner = null;

    var render = function () {
      var pct = Math.round((Math.min(step, total) / total) * 100);
      $('[data-ts-quiz-step]', root).textContent = Math.min(step + 1, total);
      $('[data-ts-quiz-pct]', root).textContent = pct + '%';
      $('[data-ts-quiz-bar]', root).style.width = pct + '%';
      steps.forEach(function (s, i) { s.hidden = i !== step; });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i <= step); });
      back.disabled = step === 0;
      steps.forEach(function (s, i) {
        $$('[data-ts-option]', s).forEach(function (o) { o.classList.toggle('is-active', !!picks[i] && picks[i].label === o.getAttribute('data-label')); });
      });
    };

    var score = function () {
      var lines = {}, tags = {};
      picks.forEach(function (p) {
        if (!p) return;
        if (p.tag) tags[p.tag] = true;
        Object.keys(p.lines).forEach(function (k) { lines[k] = (lines[k] || 0) + p.lines[k]; });
      });
      return products.map(function (pr) {
        var s = (lines[pr.line] || 0) * 10;
        if (tags['new'] && pr.isNew) s += 14;
        if (tags.classic && !pr.isNew && pr.available) s += 10;
        if (tags.limited && (pr.isNew || !pr.available)) s += 8;
        if (!pr.available) s -= 25;
        s += (pr.title.charCodeAt(0) % 7) * 0.1;
        return { p: pr, s: s };
      }).sort(function (a, b) { return b.s - a.s; });
    };

    var initials = function (t) {
      return t.split(/\s+/).filter(Boolean).slice(0, 2).map(function (w) { return w.charAt(0).toUpperCase(); }).join('');
    };

    var showResult = function () {
      var ranked = score();
      if (!ranked.length) return;
      winner = ranked[0].p;
      card.hidden = true;
      result.hidden = false;
      $('[data-ts-r-mono]', result).textContent = initials(winner.title);
      $('[data-ts-r-tag]', result).textContent = winner.seeds + '+' + winner.bonus + ' seeds';
      $('[data-ts-r-visual]', result).setAttribute('aria-label', winner.title + ' pack artwork');
      $('[data-ts-r-title]', result).textContent = winner.title;
      $('[data-ts-r-lineage]', result).textContent = winner.lineage;
      $('[data-ts-r-blurb]', result).textContent = winner.blurb || '';
      $('[data-ts-r-price]', result).textContent = winner.price;
      $('[data-ts-r-pack]', result).textContent = winner.seeds + ' feminised + ' + winner.bonus + ' free seeds';
      $('[data-ts-r-link]', result).href = winner.url;
      var ul = $('[data-ts-r-reasons]', result);
      var checkIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
      ul.innerHTML = '';
      picks.forEach(function (p) {
        if (!p) return;
        var li = document.createElement('li');
        li.innerHTML = checkIcon;
        li.appendChild(document.createTextNode(' ' + p.label));
        ul.appendChild(li);
      });
      var addBtn = $('[data-ts-r-add]', result);
      addBtn.disabled = !winner.available;
      $('[data-ts-r-add-label]', result).hidden = false;
      $('[data-ts-r-added]', result).hidden = true;
      $('[data-ts-r-checkout]', result).hidden = true;

      var list = $('[data-ts-runners]', result);
      var runners = ranked.slice(1, 4).map(function (r) { return r.p.handle; });
      $$('li[data-handle]', list).forEach(function (li) { li.hidden = true; });
      runners.forEach(function (h) {
        var li = $('li[data-handle="' + h + '"]', list);
        if (li) { li.hidden = false; list.appendChild(li); }
      });
      result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-ts-option]');
      if (opt) {
        var lines = {};
        try { lines = JSON.parse(opt.getAttribute('data-lines') || '{}'); } catch (err) { lines = {}; }
        picks[step] = { label: opt.getAttribute('data-label'), lines: lines, tag: opt.getAttribute('data-tag') };
        step += 1;
        if (step >= total) showResult(); else render();
        return;
      }
      if (e.target.closest('[data-ts-quiz-back]')) { step = Math.max(0, step - 1); render(); return; }
      if (e.target.closest('[data-ts-quiz-reset]')) {
        picks = []; step = 0; winner = null;
        result.hidden = true; card.hidden = false; render();
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var add = e.target.closest('[data-ts-r-add]');
      if (add && winner) {
        add.disabled = true;
        addItems([{ id: winner.variantId, quantity: 1 }])
          .then(function () {
            $('[data-ts-r-add-label]', result).hidden = true;
            $('[data-ts-r-added]', result).hidden = false;
            $('[data-ts-r-checkout]', result).hidden = false;
          })
          .catch(function (err) { window.alert(err.message); add.disabled = false; });
      }
    });
    render();
  }

  function init() {
    initAgeGate();
    initDrawer();
    initReveal();
    initCartBar();
    initCollection();
    initProduct();
    initQuiz();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () { initReveal(); initCollection(); initQuiz(); });
})();
